<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="images" id="img6" src="images/img6.jpg"/></p>
<p class="caption">The kind of image that helped the United States enter the war. Unrestricted submarine warfare and the loss of American lives caused a shift in opinion in the States. The original caption reads: <em class="italic">These pictures just received in this country tell part of the story of the sinking of the French liner Sontay in the Mediterranean on 10 April with a loss of forty-five lives.</em></p>
<p class="caption1">THE NEW YORK TIMES MID-WEEK PICTORIAL WW1/US001</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00d_AMERICAN_EXPEDITIONARY_FORCE.vue?ab9ee852